import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import AdminLayout from '../../layouts/AdminLayout';
import TasbeehFormModal from './TasbeehFormModal';

export default function TasbeehFormPage() {
  const history = useHistory();
  const { id } = useParams();

  const handleClose = () => {
    history.push('/tasbeeh');
  };

  const handleSuccess = () => {
    history.push('/tasbeeh');
  };

  return (
    <AdminLayout title={id ? 'Edit Dhikr' : 'Add Dhikr'}>
      <TasbeehFormModal
        open={true}
        adhkarId={id || null}
        onClose={handleClose}
        onSuccess={handleSuccess}
      />
    </AdminLayout>
  );
}
